import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { Drivers } from 'src/app/modules/entry-control/interfaces/drivers';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-edit-driver',
  templateUrl: './edit-driver.component.html',
  styleUrl: './edit-driver.component.css'
})
export class EditDriverComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private apiFull: ApiService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private modal: NgbModal,
  ) {}
  ngOnInit(): void {
    this.getState();
    if (this.driver != null) {
      this.get(this.driver);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['driver'].currentValue!=this.driver) {
      this.get(this.driver);
    }
  }
  @Output()
  success = new EventEmitter<boolean>();
  @Input()
  driver: Drivers;
  @Input()
  storesId: number;
  @Input()
  carsId: number;

  items:any;
  form1: FormGroup = this.formBuilder.group({
    id:[],
    name: ['', Validators.required],
    lastname: [''],
    rut: ['', [Validators.required, MyValidators.rut]],
    stores_id: [0],
    cars_id: [0],
    state_id: [0],
  });

  get(item: Drivers) {
    this.api.getDriver(item?.id).subscribe((res)=>{
      let data=res.data as Drivers;
      this.form1.patchValue(res.data);
      this.form1.get('rutview')?.setValue(data?.rut);
    },error=>{
      this.toast.warning(error.error.mistakes,error.error.msg,{enableHtml:true,closeButton:true});
      this.modal.dismissAll();
    });
  }
  getState(){
    this.apiFull.getState().subscribe((res)=>{
      this.items=res.data;
    });
  }

  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1
        .get('rut')
        ?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }
  update() {
    this.api.updateDrivers(this.form1).subscribe(
      (response) => {
        this.toast.success(response.msg, 'Conductores');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (err) => {
        this.toast.warning(err.error.mistakes, err.error.msg,{enableHtml:true,closeButton:true});
      }
    );
  }

  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
